// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"527":"cc8a18df","709":"18156879","935":"8d84cd22"}[chunkId] + ".chunk.css";
};